const ApiErrorsEnum = Object.freeze({
  BadRequest: 400,
  Unauthorized: 401,
  Forbidden: 403,
  NotFound: 404,
  InternalServerError: 500,
});

export default ApiErrorsEnum;
